'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var truck = require('./truck.js');
var locate = require('./locate.js');
var store = require('./store.js');
var phone = require('./phone.js');
var PackageIcon = require('./PackageIcon.js');
var clock = require('./clock.js');
var CheckMark = require('./CheckMark.js');
var PlaceholderThumbnail = require('./PlaceholderThumbnail.js');
var ArrowRight = require('./ArrowRight.js');
var Exchange = require('./Exchange.js');
var PlaceholderPictures = require('./PlaceholderPictures.js');
var OriginalPayment = require('./OriginalPayment.js');
var GiftCard = require('./GiftCard.js');
var StoreCredit = require('./StoreCredit.js');
var ShippingLabel = require('./ShippingLabel.js');
var Printerless = require('./Printerless.js');
var NarvarBadge = require('./NarvarBadge.js');
var Favorite = require('./Favorite.js');
var CheckCircle = require('./CheckCircle.js');
var Error = require('./Error.js');
var Reshop = require('./Reshop.js');
var ShippingProtection = require('./ShippingProtection.js');
var HelpCircle = require('./HelpCircle.js');

const icons = {
  Truck: truck["default"],
  Locate: locate["default"],
  Store: store["default"],
  Package: PackageIcon["default"],
  Clock: clock["default"],
  Phone: phone["default"],
  CheckMark: CheckMark["default"],
  PlaceholderThumbnail: PlaceholderThumbnail["default"],
  ArrowRight: ArrowRight["default"],
  Exchange: Exchange["default"],
  PlaceholderPictures: PlaceholderPictures["default"],
  OriginalPayment: OriginalPayment["default"],
  GiftCard: GiftCard["default"],
  Reshop: Reshop["default"],
  StoreCredit: StoreCredit["default"],
  ShippingLabel: ShippingLabel["default"],
  Printerless: Printerless["default"],
  NarvarBadge: NarvarBadge["default"],
  Favorite: Favorite["default"],
  CheckCircle: CheckCircle["default"],
  Error: Error["default"],
  ShippingProtection: ShippingProtection["default"],
  HelpCircle: HelpCircle["default"]
};
const Icon = _ref => {
  let {
    icon,
    ...props
  } = _ref;
  return icons[icon](props);
};

exports["default"] = Icon;
exports.icons = icons;
